import { BaseModel } from '@app/shared/models/base';

export enum ClientCategoryEnum {
    CLAIMNET = 'CLAIMNET'
}

export class ClientCategory extends BaseModel {
    public services: ClientCategoryService[];
    public category: ClientCategoryEnum;

    constructor(json?: any) {
        super(json);
    }
}

export class ClientCategoryService extends BaseModel {
    public name: string;
    public enabled: boolean;

    constructor(json?: any) {
        super(json);
    }
}
